import {
  setLoader,
  unSetLoader,
  setErrorMessage,
  showSnackbar,
} from "store/actions/appActions";
import { billing } from "store/requests";

export const getPatientBills = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getPatientBills",
        payload,
        addUserName: true,
      });
      return data.success;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const editPersonalDetails = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/editPersonalDetails",
        payload,
        addUserName: true,
      });
      return data.success;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const deletePatientBill = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/deletePatientBill",
        payload,
        addUserName: true,
      });
      dispatch(unSetLoader());
      return data;
    } catch (error) {}
  };
};

export const getPatientBillDocument = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(showSnackbar("Opening the document..."));
      let { data } = await billing({
        url: "/getPatientBillDocument",
        payload,
        addUserName: true,
        data: { responseType: "blob" },
      });
      const fileURL = window.URL.createObjectURL(data);
      window.open(fileURL);
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const getPatientBillReceiptPDF = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(showSnackbar("Opening the document..."));
      let { data } = await billing({
        url: "/getPatientBillReceiptPDF",
        payload,
        addUserName: true,
        data: { responseType: "blob" },
      });
      const fileURL = window.URL.createObjectURL(data);
      window.open(fileURL);
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const resendBillEmail = (payload) => {
  return async (dispatch) => {
    try {
      dispatch(showSnackbar("Sending Email"));
      let { data } = await billing({
        url: "/resendBillEmail",
        payload,
        addUserName: true,
      });
      dispatch(showSnackbar("Email sent successfully"));
      return data;
    } catch (error) {
      dispatch(showSnackbar("Failed to send the Email"));
    }
  };
};
